/* ==========================================================================
   SBD Schweiz – Ergänzungen für Impact 7.2

   Schliessen-Buttons (X) in Drawern und Popovers zuverlässig machen.

   Impact verwendet dafür "customized built-in elements" (<button is="close-button">).
   Werden diese vom Browser nicht aufgewertet, passiert beim Klick auf das X nichts,
   während ein Klick daneben das Fenster weiterhin schliesst.
   Dieses Skript schliesst das zugehörige Fenster in jedem Fall – auch aus dem Shadow DOM heraus.
   Es greift nur, wenn das Fenster nach dem Klick noch offen ist, und stört daher das
   normale Verhalten des Themes nicht.
   ========================================================================== */
(() => {
  const isCloseButton = (node) => {
    if (!node || node.nodeType !== 1) return false;
    if (node.getAttribute && node.getAttribute('is') === 'close-button') return true;
    const part = node.getAttribute && node.getAttribute('part');
    return !!part && part.indexOf('close-button') !== -1;
  };

  document.addEventListener('click', (event) => {
    const path = typeof event.composedPath === 'function' ? event.composedPath() : [event.target];

    let found = false;
    for (const node of path) {
      if (!found) {
        if (isCloseButton(node)) found = true;
        continue;
      }

      // Erstes Eltern-Element mit hide()-Methode ist das Dialog-Element
      if (node && typeof node.hide === 'function') {
        const target = node;
        // Kurz warten: falls das Theme selbst schliesst, ist danach nichts mehr zu tun
        setTimeout(() => {
          if (target.open || target.hasAttribute('open')) {
            try {
              target.hide();
            } catch (error) {
              target.removeAttribute('open');
            }
          }
        }, 60);
        return;
      }
    }
  }, true);
})();
